import { Lightbulb, CheckCircle } from 'lucide-react';

export function TipsCard() {

  const tips = [
    'Mantén tu efectivo siempre cerca del máximo para no perder oportunidades',
    'Verifica el QR del usuario antes de completar la transacción',
    'Revisa tus comisiones diarias para monitorear tu rendimiento',
    'Activa las notificaciones para recibir alertas de balance bajo',
  ];

  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg shadow border border-blue-200">
      <div className="px-6 py-4 border-b border-blue-200 bg-white bg-opacity-50">
        <div className="flex items-center gap-2">
          <Lightbulb className="w-5 h-5 text-amber-600" />
          <h3 className="text-lg font-semibold text-gray-900">Consejos del Día</h3>
        </div>
      </div>
      <div className="p-6">
        <ul className="space-y-3">
          {tips.map((tip, index) => (
            <li key={index} className="flex items-start gap-3">
              <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
              <p className="text-sm text-gray-700">{tip}</p>
            </li>
          ))}
        </ul>

        <div className="mt-6 p-4 bg-white bg-opacity-70 rounded-lg border border-blue-200">
          <p className="text-xs text-gray-600 italic">
            💡 <strong>Tip Pro:</strong> Los agentes más exitosos mantienen su balance entre 70-90%
            de capacidad y realizan recargas programadas cada semana.
          </p>
        </div>
      </div>
    </div>
  );
}

export default TipsCard;
